import { TaxMetaField } from '../../../../../../../VatReturnSettings'

export const getDisplayTitle = (field: TaxMetaField) => field.name
